import styled from 'styled-components';
import React from 'react';
import { AuthToken } from 'modules/auth/authToken';
import { useTypedSelector } from 'types/global';
import { selectAppToken, selectEnvironment } from 'modules/global';
import config from '../config';
import localhost from '../config/localhost';

const $Container = styled.div`
  background: linear-gradient(90deg, #005e3f, #003926);
  color: white;
  padding: 16px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  flex-shrink: 0;
`;

const $Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
`;

const $Button = styled.button<{
  variant?: 'primary' | 'secondary';
}>`
  padding: 8px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;

  background: white;
  color: #1b4332;
  border: none;

  &:hover {
    background: #f0f0f0;
  }
`;

const V2DashboardBanner = () => {
  const environment = useTypedSelector(selectEnvironment);
  const appToken = useTypedSelector(selectAppToken);

  const handleTryNewDashboardClick = () => {
    const accessToken = AuthToken.get();

    const isLocalEnv = process.env.REACT_APP_V2_ENV === 'localhost';
    const url = isLocalEnv ? localhost.v2DashboardUrl : config.v2DashboardUrl;

    window.open(
      `${url}?${new URLSearchParams({
        access_token: accessToken || '',
        environment,
        app_token: appToken,
      })}`,
      '_blank',
    );
  };

  return (
    <$Container data-cy="try-new-badge-dashbord">
      <$Description>Preview the new Lean Dashboard experience</$Description>
      <$Button
        onClick={handleTryNewDashboardClick}
        data-cy="try-v2-dashboard-button"
      >
        Explore dashboard
      </$Button>
    </$Container>
  );
};

export default V2DashboardBanner;
